import GenericTemplate from '_templates/GenericTemplate';
import {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Divider} from '@mui/material';

import {MainPanel} from './MainPanel';
import {SearchPanel} from './SearchPanel';
import {SearchConditions} from './types';

export const TriSurfacePolygonComparisonPage = () => {
  const {t} = useTranslation();

  //確定条件
  const [fixSearchConditions, setFixSearchConditions] = useState<SearchConditions | null>(null);

  /**
   * 検索処理
   */
  const handleSearch = useCallback((searchConditions: SearchConditions) => {
    //検索条件FIX
    setFixSearchConditions({...searchConditions}); //同じ条件で再検索できるように新しいオブジェクトにして入れる
  }, []);

  return (
    <GenericTemplate title={`${t('menu.page_name.3面間ポリゴン比較')}`}>
      <SearchPanel onSearch={handleSearch} />
      <Divider sx={{margin: '0.5em 0'}} />
      <MainPanel searchConditions={fixSearchConditions} />
      {/* <CloudDistanceDig
        pageName={`${t('menu.page_name.Cloud Distance')}: ${t('詳細')}`}
        open={open}
        onClose={handleClose}
        datas={openData}
        SearchConditions={SearchConditions}
      /> */}
    </GenericTemplate>
  );
};
